export default "__VITE_ASSET__BPLb1CGq__"